export const hasPropertySameValue =
  <T extends Record<P, unknown>, P extends keyof T>(property: P) =>
  (recordA: T) =>
  (recordB: T): boolean =>
    Object.is(recordA[property], recordB[property])
